function getCookie(cookieName) {
  const cookies = document.cookie.split("; ");
  const targetCookie = cookies.find(
    (cookie) => cookie.startsWith(`${cookieName}=`)
  );
  return targetCookie ? decodeURIComponent(targetCookie.split("=")[1]) : null;
}
function setCookie(cookieName, value, days = 365, path = "/", domain, secure = false, sameSite = "Lax") {
  const expires = /* @__PURE__ */ new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1e3);
  let cookieString = `${cookieName}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=${path}`;
  if (secure) {
    cookieString += "; secure";
  }
  cookieString += `; SameSite=${sameSite}`;
  document.cookie = cookieString;
}
async function getUsersBrowsingLocale() {
  try {
    return await fetch(
      window.Shopify.routes.root + `browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${window.Shopify.country}&language[enabled]=true&language[exclude]=${window.Shopify.locale}`
    ).then((r) => r.json());
  } catch (error) {
    throw new Error(error);
  }
}
const getParamsFromForm = (form) => {
  const formData = new FormData(form);
  const params = {};
  for (const [key, value] of formData.entries()) {
    if (key.includes("[]")) {
      const arrayKey = key.replace("[]", "");
      if (!params[arrayKey]) {
        params[arrayKey] = [];
      }
      params[arrayKey].push(value);
    } else {
      params[key] = value;
    }
  }
  return params;
};
const reloadScripts = (element) => {
  if (!element)
    return false;
  const scriptTags = element.querySelectorAll("script");
  scriptTags.forEach((oldScript) => {
    var _a;
    const newScript = document.createElement("script");
    newScript.textContent = oldScript.textContent;
    (_a = oldScript.parentNode) == null ? void 0 : _a.replaceChild(newScript, oldScript);
  });
  return true;
};
const isEmpty = (value) => {
  if (Array.isArray(value)) {
    return value.length === 0;
  } else if (typeof value === "object" && value !== null) {
    return Object.keys(value).length === 0;
  } else {
    return value === "";
  }
};
function debounce(func, wait) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => func.apply(this, args), wait);
  };
}
function isMobile() {
  return window.innerWidth <= 768;
}
const removeEmptyKeys = (object) => {
  const keys = Object.keys(object);
  keys.forEach((key) => {
    if (object[key] === null || object[key] === void 0 || isEmpty(object[key])) {
      delete object[key];
    }
  });
  return object;
};
function isAuthorized(product, customer) {
  var _a, _b;
  const accessRestriction = product.accessRestriction;
  const isLoggedIn = customer && customer.id;
  const isEfpMember = (_a = customer == null ? void 0 : customer.tags) == null ? void 0 : _a.includes("efp-member");
  const isPbMember = (_b = customer == null ? void 0 : customer.tags) == null ? void 0 : _b.includes("pb-member");
  switch (accessRestriction) {
    case "all":
      return isLoggedIn;
    case "efp":
      return isEfpMember;
    case "pb":
      return isPbMember;
    case "efp_pb":
      return isEfpMember && isPbMember;
    default:
      return true;
  }
}
export {
  getCookie as a,
  getParamsFromForm as b,
  removeEmptyKeys as c,
  debounce as d,
  isMobile as e,
  getUsersBrowsingLocale as g,
  isAuthorized as i,
  reloadScripts as r,
  setCookie as s
};
